import { render, staticRenderFns } from "./CardsVehiculos.vue?vue&type=template&id=66c13a0a"
import script from "./CardsVehiculos.vue?vue&type=script&lang=js"
export * from "./CardsVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports